import { Outlet, useLocation, useNavigate } from 'react-router'

import { Tabs, TabsList, TabsTrigger } from '@/components/elements/tabs'
import { Layout } from '@/components/Layout'

/**
 * Admin hub that groups account-level management into tabs (RSCX-320):
 *
 *   Accounts      — the existing facility/account list (primary)
 *   Organizations — parent accounts that own and share content with facilities
 *
 * Mirrors the CoursesHub / AccountManagement tabs pattern. The tab children
 * render Layout-less content; this hub owns the Layout + tab chrome.
 */
const BASE_PATH = '/admin/accounts'

const TABS = [
  { value: 'accounts', label: 'Accounts' },
  { value: 'organizations', label: 'Organizations' },
]

export const AccountsHub = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const subPath = location.pathname.slice(BASE_PATH.length).replace(/^\/+/, '')
  const activeTab = subPath.split('/').filter(Boolean)[0] ?? TABS[0].value

  // Accounts is the index tab (lives at BASE_PATH itself); the rest are
  // sub-paths. Keeps the landing URL at /admin/accounts, not …/accounts.
  const handleTabChange = (value) =>
    navigate(value === TABS[0].value ? BASE_PATH : `${BASE_PATH}/${value}`)

  return (
    <Layout breadcrumbs={['Admin', 'Accounts']}>
      <Layout.Heading title="Accounts" />

      <Tabs value={activeTab} onValueChange={handleTabChange} className="mt-4">
        <TabsList>
          {TABS.map((tab) => (
            <TabsTrigger key={tab.value} value={tab.value}>
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>

        <div className="mt-4">
          <Outlet />
        </div>
      </Tabs>
    </Layout>
  )
}

export default AccountsHub
